// import React, { useState, useContext, useEffect } from 'react';
// import Master from "../../utils/Master";
// import axios from "axios";
// import './grouplist.css';
// import Iconslist from '../Iconslist/Iconslist';
// import { Trash2 } from "lucide-react";

// const Grouplist = (props) => {

//     const {
//         grouplist,
//         setgrouplist,
//         setselectedgroupid,
//         apicalled,
//         setapicalled
//     } = useContext(Master);

//     const [showConfirm, setShowConfirm] = useState(false);
//     const [deleteData, setDeleteData] = useState(null);

//     useEffect(() => {

//         axios
//             .get(process.env.REACT_APP_API_BASE + "group")
//             .then((response) => {
//                 setgrouplist(response.data)
//                 // console.log("response of api group", response.data);
//             })

//             .catch((error) => {
//                 console.error('API call error:', error);
//             });

//     }, [])

//     const confirmDelete = (iconlist, iconid) => {
//         setDeleteData({ iconlist, iconid });
//         setShowConfirm(true);
//     }

//     const handleDeleteIcons = () => {
//         if (!deleteData) return;

//             axios.delete(process.env.REACT_APP_API_BASE + "group/" + `${deleteData.iconid}`, {
//             data: { iconlist: deleteData.iconlist, id: deleteData.iconid },
//             headers: {
//               "Content-type": "application/json",
//             },
//           })
//                 .then((response) => {
//                     if (response.data.success) {
//                         let newgrouplist = grouplist.filter((item) => item.iconlist !== deleteData.iconlist);
//                         setgrouplist(newgrouplist);
//                     }
//                 })
//                 .catch((error) => {
//                     console.error('API call error:', error);
//                 })
//                 .finally(() => {
//                     setDeleteData(null);
//                     setShowConfirm(false);
//                     // setapicalled(!apicalled);
//                 });
//     };

//     const handleUploadUserfile = (event, file, id, program) => {
//         setselectedgroupid(id);
//         if (!file.size) return;

//         const form = new FormData();

//         form.append("csv", file);
//         form.append("groupid", id);
//         form.append("program", program);

//         axios
//             .post(process.env.REACT_APP_API_BASE+"generate", form, {
//                 mode: "no-cors",
//                 headers: {
//                     "Content-type": "multipart/form-data",
//                 },
//             })
//             .then((response) => {
//                 setapicalled(!apicalled)

//             })
//             .catch((error) => {
//             })
//             .finally(() => {
//             }
//             );
//     };

//     return (

//         <div className='grouplist'>
//             <table className='tablemain'>
//             <thead className='headsection'>
//             <tr className='head'>
//                 <th>Name</th>
//                 <th>Icons</th>
//                 <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody className='body'>
//           {grouplist && grouplist.length > 0 ? (
//             grouplist.map((item, i) => (
//             <tr key={i} className={1%2==0?'even':'odd'}>
//               <td>{item.name}</td>
//               <td><Iconslist groupicons={(item.iconlist || "").split(',').filter(Boolean)} selected={true}/></td>
//               <td>
//               <Trash2
//                 color="red"
//                 size={20}
//                 style={{ cursor: "pointer" }}
//                 onClick={() => confirmDelete(item.iconlist, item.id)}
//               />
//             </td>
//             </tr>
//           ))
//         ) : (
//             <tr><td colSpan={2}>No groups available</td></tr>
//           )}
//         </tbody>
//       </table>

//             {/* Confirm Popup */}
//         <div>
//             {showConfirm && (
//                 <div className="popup-overlay">
//                     <div className="popup-box">
//                         <h3>Are you sure?</h3>
//                         <p>Do you really want to delete this group.</p>
//                         <div className="popup-buttons">
//                         <button className="btn btn-danger" onClick={ handleDeleteIcons }>
//                             Yes
//                         </button>
//                         <button
//                             className="btn btn-cancel"
//                             onClick={() => setShowConfirm(false)}
//                         >
//                             Cancel
//                         </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     </div>
//     );
// };

// export default Grouplist;

import React, { useState, useContext, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Typography,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { Trash2 } from "lucide-react";
// import axios from "axios";
import axios from "../../api/axios";
import Master from "../../utils/Master";
import Iconslist from "../Iconslist/Iconslist";
import { Navigate, useNavigate } from "react-router-dom";

const Grouplist = () => {
  const {
    grouplist,
    setgrouplist,
    setselectedgroupid,
    apicalled,
    setapicalled,
  } = useContext(Master);

  const navigate = useNavigate();

  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [loading, setLoading] = useState(false);

  const admin = localStorage.getItem("certificaterole") === "certificateadmin";

  // console.log("admin value in grouplist", admin);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`group`)
      .then((response) => setgrouplist(response.data))
      .catch((error) => console.error("API call error:", error))
      .finally(() => setLoading(false));
  }, []);

  //   console.log("grouplist 😒😒😒😒", grouplist);
  const confirmDelete = (iconlist, iconid) => {
    setDeleteData({ iconlist, iconid });
    setShowConfirm(true);
  };

  const handleDeleteIcons = () => {
    if (!deleteData) return;

    axios
      .delete(`group/${deleteData.iconid}`, {
        data: {
          iconlist: deleteData.iconlist,
          id: deleteData.iconid,
        },
        headers: {
          "Content-type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          const newgrouplist = grouplist.filter(
            (item) => item.iconlist !== deleteData.iconlist
          );
          setgrouplist(newgrouplist);
        }
      })
      .catch((error) => console.error("API call error:", error))
      .finally(() => {
        setDeleteData(null);
        setShowConfirm(false);
      });
  };

  const addIconGroup = () => {
    navigate("/addicongroups");
  };

  const handleUploadUserfile = (event, file, id, program) => {
    setselectedgroupid(id);
    if (!file.size) return;

    const form = new FormData();
    form.append("csv", file);
    form.append("groupid", id);
    form.append("program", program);

    axios
      .post(`generate`, form, {
        mode: "no-cors",
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(() => setapicalled(!apicalled))
      .catch((error) => console.error("Upload error:", error));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Group List
        </Typography>

        <Button
          variant="contained"
          onClick={() => addIconGroup()}
          sx={{ mb: 3 }}
        >
          Add Icon Group
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} elevation={3}>
          <Table
            sx={{
              "& .MuiTableRow-root": {
                height: "45px !important", // force override default MUI height
              },
              "& .MuiTableCell-root": {
                paddingTop: "4px !important",
                paddingBottom: "4px !important",
                fontSize: "0.9rem",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "#d2d2d2",
                "& th": { textAlign: "center" },
              }}
            >
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Icons</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {grouplist && grouplist.length > 0 ? (
                grouplist.map((item, i) => (
                  <TableRow
                    key={i}
                    sx={{
                      backgroundColor: i % 2 === 0 ? "#fafafa" : "white",
                    }}
                  >
                    <TableCell align="center">{item.name}</TableCell>
                    <TableCell>
                      <Iconslist
                        groupicons={(item.iconlist || "")
                          .split(",")
                          .filter(Boolean)}
                        selected={true}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="error"
                        disabled={!admin}
                        style={{ cursor: admin ? "pointer" : "not-allowed" }}
                        onClick={() => confirmDelete(item.iconlist, item.id)}
                      >
                        <Trash2 size={20} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No groups available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Confirm Delete Dialog */}
      <Dialog
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        aria-labelledby="confirm-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            width: "500px", // you can set custom width here
            maxWidth: "80%", // responsive max width
          },
        }}
      >
        <DialogTitle id="confirm-dialog-title">Delete Group</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this group?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowConfirm(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleDeleteIcons} color="error" variant="contained">
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Grouplist;
